import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, Typography, Box } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import EventAvailableOutlinedIcon from '@material-ui/icons/EventAvailableOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import EventBusyOutlinedIcon from '@material-ui/icons/EventBusyOutlined'
import ThreeStateRadioGroup from 'components/ThreeStateRadioGroup'
import { connect } from 'react-redux'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import PropTypes from 'prop-types'
import { team as teamModule } from '../../redux/modules'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: 'auto',
    padding: theme.spacing(4),
    marginBottom: '1rem',
  },
  titleWrapper: {
    marginBottom: theme.spacing(3),
  },
  title: {
    paddingBottom: theme.spacing(0.5),
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginRight: 0,
      marginLeft: 0,
      '& > :nth-child(1)': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .MuiFormControl-root': {
      marginBottom: 0,
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
}))

const PlayerAttendanceResponse = ({ team, patchTeam }) => {
  const classes = useStyles()
  const featureGuard = useFeatureAccessGuard()

  const [defaultResponse, setDefaultResponse] = useState(
    team.default_player_attendance_status
  )

  // Uncomment and correct when player default avialability feature flag added
  // const { enabled: hasPlayerAvailabilityEnabled } = useTeamFeature(
  //   TEAM_FEATURE_FLAGS.player_availability_enabled
  // )

  const handleDefaultResponseChange = (value) => {
    //  Uncomment and correct when player default avialability feature flag added
    // if (featureGuard(hasPlayerAvailabilityEnabled)) return

    setDefaultResponse(value)
    patchTeam(team.uuid, { default_player_attendance_status: value })
  }

  return (
    <Card className={classes.root}>
      <Box className={classes.titleWrapper}>
        <Typography variant="h3" component="h3" className={classes.title}>
          <Translate id="player.attendance-response.title" />
          {/* Uncomment and correct when player default avialability feature flag added  */}
          {/* {!hasPlayerAvailabilityEnabled ? (
            <LockIconComponent context="label" />
          ) : null} */}
        </Typography>
        <Typography variant="h6" component="h6">
          <Translate id="player.attendance-response.select-default" />
        </Typography>
      </Box>
      <Box className={classes.section}>
        <Typography variant="h4" component="h4">
          <Translate id="player.attendance-response.default-player" />
        </Typography>
        <ThreeStateRadioGroup
          value={defaultResponse}
          options={[
            {
              icon: <EventAvailableOutlinedIcon fontSize="small" />,
              value: 'AVAILABLE',
            },
            {
              icon: <DateRangeOutlinedIcon fontSize="small" />,
              value: 'NOT_RESPONDED',
            },
            {
              icon: <EventBusyOutlinedIcon fontSize="small" />,
              value: 'NOT_AVAILABLE',
            },
          ]}
          onChange={handleDefaultResponseChange}
        />
      </Box>
    </Card>
  )
}

PlayerAttendanceResponse.propTypes = {
  patchTeam: PropTypes.func.isRequired,
  team: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    default_player_attendance_status: PropTypes.string.isRequired,
  }).isRequired,
}

export default connect(
  ({ team }) => ({
    team,
  }),
  {
    patchTeam: teamModule.patchTeam,
  }
)(PlayerAttendanceResponse)
